import { render, staticRenderFns } from "./organization-connection-request-list.html?vue&type=template&id=0f561ad0&scoped=true&external"
import script from "./organization-connection-request-list.js?vue&type=script&lang=js&external"
export * from "./organization-connection-request-list.js?vue&type=script&lang=js&external"
import style0 from "./organization-connection-request-list.scss?vue&type=style&index=0&id=0f561ad0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f561ad0",
  null
  
)

export default component.exports